import { render, staticRenderFns } from "./fccTabelaGabarito.vue?vue&type=template&id=de62348c&scoped=true"
import script from "./fccTabelaGabarito.vue?vue&type=script&lang=js"
export * from "./fccTabelaGabarito.vue?vue&type=script&lang=js"
import style0 from "./fccTabelaGabarito.vue?vue&type=style&index=0&id=de62348c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de62348c",
  null
  
)

export default component.exports